// extracted by mini-css-extract-plugin
export default {"island":"island--zEEST","padding":"padding--Wb8Uf"};